import { WallboxHardwareModel } from 'src/Libs/wallboxes/models'
import { ChargingSessionResponseDto } from '../api/dto/charging-session-response.dto'
import { ChargingSessionModelV1 } from '../models/charging-session.model'
import { EMobilityWallboxPricesModel } from 'src/Libs/e-mobility/emobility-wallbox/models/e-mobility-wallbox-models'

/**
 * TODO: this exists 3 times now and needs to be refactored asap
 *
 * @param dto
 * @param wallboxes
 */
export const toChargingSessions = (
  dto: ChargingSessionResponseDto,
  chargePrices: (EMobilityWallboxPricesModel[] | undefined)[],
  dischargePrices: (EMobilityWallboxPricesModel[] | undefined)[],
  wallboxes: WallboxHardwareModel[]
): ChargingSessionModelV1[] => {
  if (!dto.id) {
    return []
  }

  return dto.id.map((id, index) => {
    const wallboxId = dto.wallboxID && dto.wallboxID[index] ? dto.wallboxID[index] : ''
    const wallbox = wallboxes?.find(wallbox => wallbox.wallboxId === wallboxId)
    const wallboxIndex = wallbox?.number
    const sessionStart = new Date(dto.startAt?.[index] ?? 0)

    const session: ChargingSessionModelV1 = {
      id,
      sessionID: (dto?.sessionID && dto.sessionID[index]) || '',
      serialno: (dto.serialno && dto.serialno[index]) || NaN,
      wallbox: (() => {
        const wallboxId = (dto.wallboxID && dto.wallboxID?.[index]) || ''

        const relatedWallbox = wallboxes.find(wallbox => wallbox.wallboxId === wallboxId)
        const deviceName = relatedWallbox?.deviceName

        return {
          id: (dto.wallboxID && dto.wallboxID[index]) || '',
          name: deviceName,
        }
      })(),
      carID: dto.carID && dto.carID[index],
      authentication: {
        type: (dto.authType && dto.authType[index]) || 'NONE',
        rfid: dto.authData && dto.authData[index],
      },
      status: (dto.status && dto.status[index]) || 'UNKNOWN',
      startAt: dto.startAt && dto.startAt[index],
      stopAt: dto.stopAt && dto.stopAt[index],
      durationMilliseconds: (() => {
        const chargeTimeActive = (dto?.chargeTimeActive && dto.chargeTimeActive[index]) || 0
        const chargeTimeInactive = (dto?.chargeTimeInactive && dto.chargeTimeInactive[index]) || 0

        return chargeTimeActive + chargeTimeInactive
      })(),
      chargeTimeActive: (dto.chargeTimeActive && dto.chargeTimeActive[index]) || 0,
      chargeTimeInactive: (dto.chargeTimeInactive && dto.chargeTimeInactive[index]) || 0,
      dischargeTimeActive: (dto.dischargeTimeActive && dto.dischargeTimeActive[index]) || 0,
      counterReadingStart:
        dto.chargeCounterReadingStart && dto.chargeCounterReadingStart[index] ? parseFloat(dto.chargeCounterReadingStart[index]) : 0,
      counterReadingStop: dto.chargeCounterReadingStop && dto.chargeCounterReadingStop[index] ? parseFloat(dto.chargeCounterReadingStop[index]) : 0,
      energyAll: dto.energyAll && dto.energyAll[index] ? parseFloat(dto.energyAll[index]) : 0,
      energySolar: dto.energySolar && dto.energySolar[index] ? parseFloat(dto.energySolar[index]) : 0,
      dischargeCounterReadingStart:
        dto.dischargeCounterReadingStart && dto.dischargeCounterReadingStart[index] ? parseFloat(dto.dischargeCounterReadingStart[index]) : 0,
      dischargeCounterReadingStop:
        dto.dischargeCounterReadingStop && dto.dischargeCounterReadingStop[index] ? parseFloat(dto.dischargeCounterReadingStop[index]) : 0,
      energyDischarged: dto.energyDischarged && dto.energyDischarged[index] ? parseFloat(dto.energyDischarged[index]) : 0,
      receiptData: dto.receiptData && dto.receiptData[index],
      receiptSignature: dto.receiptSignature && dto.receiptSignature[index],
      createdAt: (dto.createdAt && dto.createdAt[index]) || '',
      updatedAt: (dto.updatedAt && dto.updatedAt[index]) || '',
      chargePrice: (() => {
        const cost = priceCalc(chargePrices, sessionStart, wallboxIndex)
        return cost
      })(),
      dischargePrice: (() => {
        const cost = priceCalc(dischargePrices, sessionStart, wallboxIndex)
        return cost
      })(),
      chargePriceTotal: dto.chargePriceTotal && dto.chargePriceTotal[index] ? dto.chargePriceTotal[index] : 0,
      dynamic: dto.dynamic && dto.dynamic[index],
    }

    return session
  })
}

/** Function calculates price for charge and discharge */
const priceCalc = (price: (EMobilityWallboxPricesModel[] | undefined)[], sStart: Date, wIndex: number | undefined): number => {
  const pricesPerWallbox = price.find(pricePerWallbox => pricePerWallbox?.some(price => price.wallboxId === wIndex))
  const basePrices = pricesPerWallbox
    ?.filter(price => price.from <= sStart.getTime())
    .sort((aPrice, bPrice) => new Date(bPrice.from).getTime() - new Date(aPrice.from).getTime())

  if (!basePrices?.length) {
    return 0
  }

  const cost = basePrices[0].price
  return cost
}
